(function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .controller('LotAllocateModalController', LotAllocateModalController);

    LotAllocateModalController.$inject = ['$uibModalInstance', 'myLots', 'mySContracts', 'ToastrService', 'Shipment',
        'LotCustomService', 'ContractCustomService', 'ShipmentCustomService'];

    function LotAllocateModalController($uibModalInstance, myLots, mySContracts, ToastrService, Shipment,
                                        LotCustomService, ContractCustomService, ShipmentCustomService) {
        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.onQueryingShipmentNumber = onQueryingShipmentNumber;
        vm.onShipmentNumberSelected = onShipmentNumberSelected;
        vm.init = init;
        vm.loadShipment = loadShipment;

        vm.lots = myLots.data;
        vm.si = null;
        vm.selectedShipment = null;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        init();

        function init() {
            var foundPurchSi = 0;
            for (var i = 0; i < vm.lots.length; i++) {
                console.log(vm.lots[i].purchSiId);
                if (vm.lots[i].purchSiId && vm.lots[i].purchSiId > 0) {
                    foundPurchSi = vm.lots[i].purchSiId;
                    break;
                }
            }
            if (foundPurchSi > 0) {
                vm.loadShipment(foundPurchSi);
            }
        }

        function onQueryingShipmentNumber(keyword) {
            return ShipmentCustomService.searchShipments(keyword).then(function(response) {
                return response.data;
            });
        }

        function onShipmentNumberSelected($item) {
            var shipmentId = $item.id;
            vm.loadShipment(shipmentId);
        }

        function loadShipment(shipmentId) {
            Shipment.get({id: shipmentId}, function (response) {
                vm.selectedShipment = response;
                if (!vm.si) {
                    vm.si = {
                        id: vm.selectedShipment.id,
                        siNum: vm.selectedShipment.siNum
                    };
                }
            });
        }

        function save() {
            angular.forEach(vm.lots, function (value, index) {
                if (vm.lots[index].lotStatus === "AVAILABLE") {
                    vm.lots[index].lotStatus = "ALLOCATED";
                }
                if (vm.selectedShipment) {
                    vm.lots[index].purchSi = vm.selectedShipment;
                    if (vm.selectedShipment.saleContract) {
                        vm.lots[index].allocSale = vm.selectedShipment.saleContract;
                        vm.lots[index].allocSi = vm.selectedShipment;
                    }
                }
            });
            console.log(vm.lots);
            LotCustomService.allocateLots(vm.lots).then(function (response) {
                ToastrService.success("Save Success!", "Success!");
                console.log("my response is: " + JSON.stringify(response));
                $uibModalInstance.close(response);
            }, function (error) {
                ToastrService.error("Something went wrong", "Error!");
            });
        }
    }
})();
